import script from "./product-list.vue?vue&type=script&setup=true&lang=js"
export * from "./product-list.vue?vue&type=script&setup=true&lang=js"

import "./product-list.vue?vue&type=style&index=0&id=96eb102a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Astig_Counter_tFv5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96eb102a"]])

export default __exports__